import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {useCallback, useEffect, useState} from 'react';
import {RelationalGroup} from '../index-search/RelationshipGroupPopup';
import {getRelationalGroups} from '../../../api/EcaServices';

const useRelationGroups = () => {
  const clientId = useSelector(
    (state: RootState) => state.selectedClient.clientId
  );
  const projectId = useSelector((state: RootState) => state.reports.projectId);

  const [relationalGroups, setRelationalGroups] = useState<RelationalGroup[]>(
    []
  );

  const fetchRelationGroups = useCallback(async () => {
    try {
      const params = `?clientId=${clientId}&projectId=${projectId}`;
      let relationalGroups: RelationalGroup[] = [];
      const result = await getRelationalGroups(params);
      relationalGroups = (result?.data?.data ?? []).map(
        (group: RelationalGroup, index: number) => {
          return {
            ...group,
            index: index + 1,
          };
        }
      );
      setRelationalGroups([...relationalGroups]);
    } catch (_) {
      /* empty */
    }
  }, [clientId, projectId]);

  useEffect(() => {
    fetchRelationGroups();
  }, [fetchRelationGroups]);

  return {
    relationalGroups,
  };
};

export {useRelationGroups};
